import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import { NavigationHighlight } from '../Elements/SVG/SVG';
import { translate } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './Navigation.scss';

class Navigation extends Component {
	render() {
		const { navigation, setup, scrollNavigation, changeLanguage, currentSection, pinNavigation } = this.props;
		const { language } = setup;
		const navStyles = {};

		if (pinNavigation > 0) {
			navStyles.position = 'absolute';
			navStyles.top = pinNavigation + (window.innerWidth > 600 ? 18 : 6);
		}

		if (!navigation.header) return null;
		let navigationPosition = null;
		if (currentSection !== null) {
			navigationPosition = 0;
			navigation.header.forEach((link, i) => {
				if (translate(setup, link, 'uri').indexOf(currentSection) !== -1) navigationPosition = i + 1;
			});
		}

		return (
			<nav className={s.navigation} style={navStyles}>
				<ul className={s.navigation_links} ref={this.links}>
					<li className={s.navigation_links_column} key="#coalesce-create">
						<a className={s.navigation_links_column_link} href="#coalesce-create">Coalesce Create</a>
					</li>
					{
						navigation.header.map((level1) => {
							const level1URI = translate(setup, level1, 'uri');

							return (
								<li className={s.navigation_links_column} key={urlify(level1URI)}>
									<a className={s.navigation_links_column_link} href={level1URI} onClick={scrollNavigation}><span>{translate(setup, level1, 'title')}</span></a>
								</li>
							);
						})
					}
					<li className={[s.navigation_links_column, s.navigation_links_column__languages].join(' ')}>
						{
							Object.keys(setup.languages).map((lang) => {
								if (lang === language) {
									return <span className={s.navigation_links_column_link} key={lang}>{lang.toUpperCase()}</span>;
								}
								return <Link data-language={lang} key={lang} className={s.navigation_links_column_link} to={`/${lang}`} onClick={changeLanguage}>{lang.toUpperCase()}</Link>;
							})
						}
					</li>
				</ul>
				<div className={[s.navigation_underline, s[`navigation_underline__${language}`], (navigationPosition !== null ? s[`navigation_underline__step${navigationPosition}`] : null)].join(' ')}>
					<NavigationHighlight language={language} />
				</div>
			</nav>
		);
	}
}

const mapState = (state, { navigation, pageType, location, setup }) => ({ navigation, pageType, location, setup });

export default connect(mapState)(Navigation);
